import { clsx } from 'clsx';

interface StatusPillProps {
  label: string;
  tone: 'open' | 'partial' | 'closed' | 'neutral';
}

export function StatusPill({ label, tone }: StatusPillProps) {
  return <span className={clsx('status-pill', `status-${tone}`)}>{label}</span>;
}

